import React, { Component } from 'react';
import './Custom.css';
import { Link } from 'react-router-dom';

class HeaderStrip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [
                "JUST LAUNCHED",
                "DOWNLOAD OUR KICKSFINDER APP"
            ]
        };
    }

    render() {
        const { messages } = this.state;

        return (
            <div className="header-strip">
                <div className="header-strip-content">
                    {/* Repeat messages enough times to fill the scrolling area, simulating infinite repeat */}
                    {Array.from({ length: 20 }).map((_, repeatIdx) =>
                        messages.map((message, index) => (
                            <React.Fragment key={`${repeatIdx}-${index}`}>
                                <span className="header-strip-bullet"></span>
                                <span className="header-strip-text"><Link to="/app">{message}</Link></span>
                            </React.Fragment>
                        ))
                    )}
                </div>
            </div>
        );
    }
}

export default HeaderStrip;
